import { Box, Typography } from "@mui/material";
import ChatItem, { ChatLoadingItem } from "./ChatItem";
import { Chat } from "../../../types";
import { useTranslation } from "react-i18next";

const ChatList = ({
  chats,
  userId,
  isLoading,
}: {
  chats: Chat[];
  userId: number | null;
  isLoading: boolean;
}) => {
  let ChatListContent;

  ChatListContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        height: "100%",
        maxHeight: "950px",
        padding: "27px 15px 0",
      }}
    >
      {isLoading &&
        [...Array(7)].map((_, idx) => (
          <ChatLoadingItem key={idx} isLast={idx === 6} />
        ))}
      {!isLoading &&
        chats.length > 0 &&
        chats.map((chat: Chat, index: any) => {
          const IS_LAST: boolean = chats.length === index + 1;
          return (
            <ChatItem
              key={chat.id}
              chat={chat}
              userId={userId}
              isLast={IS_LAST}
            />
          );
        })}
      {!isLoading && chats.length === 0 && <EmptyChatList />}
    </Box>
  );
  return ChatListContent;
};

export default ChatList;

const EmptyChatList = () => {
  const { t } = useTranslation();

  return (
    <Typography
      variant="body14SemiBold"
      sx={{ padding: "27px 15px 0", display: "block" }}
    >
      {t("pages.chat.noChatAtTheMoment")}
    </Typography>
  );
};
